import React from 'react';
import { CouponStatusBadge } from './CouponStatusBadge';
import { CouponRowActions } from './CouponRowActions';
import {
  formatExpiresAt,
  formatCycles,
  formatAppliesTo,
  formatDiscount,
} from '../utils';

export const columns = [
  {
    name: 'Nome cupom',
    selector: (row) => row.code,
    minWidth: '120px',
  },
  {
    name: 'Data de expiração',
    selector: (row) => row.expiresAt,
    cell: (row) => <div>{formatExpiresAt(row.expiresAt)}</div>,
    width: '180px',
    sortable: true,
    grow: 1.5,
  },
  {
    name: 'Aplicável em',
    selector: (row) => formatAppliesTo(row),
    minWidth: '160px',
    grow: 1.5,
  },
  {
    name: 'Ciclo',
    selector: (row) => formatCycles(row.cyclesCount),
    width: '100px',
  },
  {
    name: 'Desconto',
    selector: (row) => formatDiscount(row),
    width: '130px',
  },
  {
    name: 'Status',
    cell: (row) => <CouponStatusBadge coupon={row} />,
    width: '120px',
  },
  {
    name: 'Opções',
    cell: (row) => <CouponRowActions coupon={row} />,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: '100px',
  },
];
